import { createFileRoute, notFound } from "@tanstack/react-router";
import type { JSX } from "react";

import { RevenueReportPage } from "@/features/reports";
import { isFeatureEnabled } from "@/shared/lib/feature-flags";

function RevenueRoute(): JSX.Element {
  return <RevenueReportPage />;
}

export const Route = createFileRoute("/_authenticated/revenue-report")({
  beforeLoad: () => {
    // Behind PUBLIC_FEATURE_REVENUE_REPORT (sino-legacy has no revenue report);
    // the sidebar entry is hidden by the same flag, this guards direct navigation.
    if (!isFeatureEnabled("revenue_report")) throw notFound();
  },
  component: RevenueRoute,
});
